export default "__VITE_ASSET__68ce1b2f__"